import styled from 'styled-components';
import { colors } from '@alixpartners/ui-components';

export const Wrapper = styled.div`
	display: flex;
	width: 100%;
	padding: 20px 24px 0 24px;
	min-height: 108px;
	background-color: ${colors.grey1};
	justify-content: space-between;
`;

export const LoadingWrapper = styled.div`
	height: 100%;
	width: 100%;
	display: flex;
	flex-direction: column;
	justify-content: center;
`;

export const Item = styled.div`
	display: flex;
	flex-direction: column;
	white-space: nowrap;
	padding-right: 10px;

	&:last-child {
		padding-right: 0;
	}
`;

export const Label = styled.div`
	font-weight: 400;
	font-size: 11px;
	color: ${colors.grey6};
	padding-bottom: 4px;
	height: 20px;
	display: flex;
	align-items: center;
`;

export const TooltipIcon = styled.div`
	padding-left: 4px;
	margin-bottom: 2px;
	display: flex;
`;

export const Value = styled.div`
	font-weight: 500;
	font-size: 26px;
	line-height: 35px;
	letter-spacing: 0.3px;
	color: ${colors.grey8};
`;

export const StatusContainer = styled.div`
	width: 144px;
`;

export const TooltipContent = styled.div`
	text-align: left;
	padding: 4px;

	span {
		font-weight: bold;
	}
`;
